import React from 'react'
import clsx from 'clsx'
import styles from './ContentSection.module.scss';
import Skeleton from '../Skeleton';

type ContentSectionProps = {
  title?: string,
  children?: React.ReactNode,
  headerRight?: React.ReactNode,
  noMargin?: boolean,
  className?: string,
  style?: any,
  skeleton?: boolean,
  noHeader?: boolean,
  smallTitle?: boolean,
}

function ContentSection({
  title,
  children = null,
  headerRight,
  noMargin = false,
  className,
  style,
  skeleton = false,
  noHeader,
  smallTitle = false,
}: ContentSectionProps) {
  if (skeleton) {
    return (
      <section
        className={clsx(
          styles.container,
          noMargin && styles.containerNoMargin,
          smallTitle && styles.containerSmallTitle,
          className && className,
        )}
        style={style}
      >
        {!noHeader ? (
          <header className={styles.header}>
            {title ? (
              <h2 className={styles.title}>{title}</h2>
            ) : (
              <Skeleton className={styles.title} style={{ width: '50%' }} />
            )}
            { headerRight && (
              <div className={styles.headerRight}>
                {headerRight}
              </div>
            )}
          </header>
        ) : null}
        {children === undefined && (
          <Skeleton className={styles.title} style={{ height: '300px' }} />
        )}
        {children}
      </section>
    )
  }
  return (
    <section
      className={clsx(
        styles.container,
        noMargin && styles.containerNoMargin,
        smallTitle && styles.containerSmallTitle,
        className && className,
      )}
      style={style}
    >
      {!noHeader ? (
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          { headerRight && (
            <div className={styles.headerRight}>
              {headerRight}
            </div>
          )}
        </header>
      ) : null}
      {children}
    </section>
  )
}

export default ContentSection
